'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import classNames from 'classnames'

import { LanguagesProps } from './Languages.schema'

import Link from '@/link/Link'
import Icon from '@/icon/Icon'
import { i18n, Locale } from '@/i18n/i18n-config'

const Languages = (props: LanguagesProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const pathname = usePathname()
    const availableLocaleNames = props.availableLocaleNames || i18n.localeNames;
    const availableLocales = props.availableLocales || i18n.locales;

    const className: string = classNames(
        'languages',
        props.isInverted && 'is-inverted',
        props.className
    )

    const getRedirectedPathName = (locale: Locale) => {
        if (!pathname) {
            return "/"
        }

        const segments = pathname.split("/")

        segments[1] = locale

        return segments.join("/")
    }

    useEffect(() => {
        const onClick = () => {
            setIsOpen(false)
        }

        window.addEventListener('click', onClick)

        return () => {
            window.removeEventListener('click', onClick)
        }
    })

    return (
        <nav className={className} onClick={(e) => e.stopPropagation()}>
            <button
                className='languages__button'
                aria-label={props.label}
                onClick={() => setIsOpen(!isOpen)}
            >
                {props.currentLanguage}
                <Icon className='languages__icon' name='chevron-down' />
            </button>
            {isOpen && (
                <ul className="languages__list">
                    { availableLocaleNames.map((locale, index) => {
                        const isCurrent = locale === props.currentLanguage

                        return (
                            <li className={classNames('languages__item', { 'is-current': isCurrent })} key={index}>
                                {isCurrent ? (
                                    <p className='languages__link' aria-label={`${locale} - ${props.currentLabel}`}>
                                        {locale}
                                    </p>
                                ) : (
                                    <Link
                                        className="languages__link"
                                        aria-label={`${locale} - ${props.currentLabel}`}
                                        href={getRedirectedPathName(availableLocales[index])}
                                        onClick={() => setIsOpen(false)}
                                    >
                                        {locale}
                                    </Link>
                                )}
                            </li>
                        )
                    })}
                </ul>
            )}
        </nav>
    )
}

export default Languages